import { render } from "./UserDetailName.vue?vue&type=template&id=74ef81d8&scoped=true"
import script from "./UserDetailName.vue?vue&type=script&lang=js"
export * from "./UserDetailName.vue?vue&type=script&lang=js"

import "./UserDetailName.vue?vue&type=style&index=0&id=74ef81d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef81d8"]])

export default __exports__